import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=54c9cffd&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=54c9cffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9cffd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c9cffd')) {
      api.createRecord('54c9cffd', component.options)
    } else {
      api.reload('54c9cffd', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=54c9cffd&scoped=true&", function () {
      api.rerender('54c9cffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26NSAI47OscGW/JS/comp/DocBox.vue"
export default component.exports